import React from 'react'
import { FilterOptions, FilterState } from '../types/plant-filter.types'

interface InlineFiltersProps {
  filterOptions: FilterOptions
  filters: FilterState
  expandedFilters: Record<string, boolean>
  toggleFilter: (filterName: string) => void
  handleFilterChange: (filterType: string, value: string) => void
  handleNumericFilterChange: (filterType: string, value: string) => void
  clearAllFilters: () => void
  searchTerm: string
  setSearchTerm: (searchTerm: string) => void
}

const filterLabels: Record<string, string> = {
  category: 'Grupa użytkowa',
  form: 'Forma rośliny',
  flowerColor: 'Kolor kwiatów',
  leafColor: 'Kolor liści',
  soilType: 'Typ gleby',
  sunExposure: 'Nasłonecznienie',
  growthRate: 'Tempo wzrostu',
  habit: 'Pokrój',
  leafType: 'Typ liści',
  floweringSeason: 'Pora kwitnienia',
  fruits: 'Owoce',
  fruitingSeason: 'Pora owocowania',
  soilMoisture: 'Wilgotność gleby',
  soilPh: 'pH gleby',
  features: 'Cechy',
  gardenTypes: 'Typ ogrodu',
  usage: 'Zastosowanie',
  hardiness: 'Mrozoodporność'
}

const InlineFilters: React.FC<InlineFiltersProps> = ({
  filterOptions,
  filters,
  expandedFilters,
  toggleFilter,
  handleFilterChange,
  handleNumericFilterChange,
  clearAllFilters,
  searchTerm,
  setSearchTerm
}) => {
  return (
    <div className='tw-flex tw-flex-wrap tw-gap-2 tw-items-center'>
      <div className='tw-flex tw-flex-col md:tw-flex-row tw-items-center tw-gap-4'>
        <div className='tw-relative'>
          <input
            type='text'
            className='tw-w-full tw-px-4 tw-py-2 tw-border tw-border-gray-300 tw-rounded-md tw-focus:outline-none tw-focus:ring-2 tw-focus:ring-teal tw-focus:border-transparent'
            placeholder='Wyszukaj po nazwie...'
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          {searchTerm && (
            <button
              className='tw-absolute tw-right-2 tw-top-1/2 tw-transform tw--translate-y-1/2 tw-text-gray-400 hover:tw-text-gray-600'
              onClick={() => setSearchTerm('')}
            >
              <i className='fas fa-times' />
            </button>
          )}
        </div>
      </div>
      {(['category', 'form'] as Array<keyof FilterOptions>).map((key) => (
        <div key={key} className='tw-relative'>
          <button
            type='button'
            className='tw-bg-white tw-border tw-border-gray-300 tw-rounded tw-px-3 tw-py-1 tw-text-sm tw-flex tw-items-center tw-gap-2 hover:tw-bg-gray-100'
            onClick={() => toggleFilter(key)}
          >
            {filterLabels[key as string] || key}
            <i className={`fas fa-chevron-${expandedFilters[key as string] ? 'up' : 'down'} tw-ml-1 tw-text-xs`} />
          </button>
          {expandedFilters[key as string] && (
            <div className='tw-absolute tw-z-50 tw-bg-white tw-border tw-shadow-lg tw-mt-1 tw-rounded tw-p-2 tw-min-w-[180px] tw-max-h-60 tw-overflow-y-auto'>
              {filterOptions[key]?.map((option: { id: string, label: string }) => (
                <label key={option.id} className='tw-flex tw-items-center tw-gap-2 tw-py-1 tw-cursor-pointer'>
                  <input
                    type='checkbox'
                    checked={(filters[key as keyof FilterState] as string[])?.includes(option.id)}
                    onChange={() => handleFilterChange(key as string, option.id)}
                    className='tw-form-checkbox tw-h-4 tw-w-4'
                  />
                  <span className='tw-text-sm'>{option.label}</span>
                </label>
              ))}
            </div>
          )}
        </div>
      ))}
      <button
        className='tw-bg-red-500 tw-text-white tw-rounded tw-px-3 tw-py-1 tw-text-sm hover:tw-bg-red-600'
        onClick={clearAllFilters}
      >
        Wyczyść wszystkie filtry
      </button>
    </div>
  )
}

export default InlineFilters
